<template>
  <v-container class="text-center" fluid>
    <v-icon color="red" size="50">mdi-package-variant</v-icon>
    <h2 class="red--text" style="font-size: 2.5rem">
      {{ $t("page404.subject") }}
    </h2>
    <div style="font-size: 1.5rem">{{ $t("page404.description") }}</div>
    <v-btn @click="goHome" class="mt-5" color="primary">
      <v-icon small class="mr-1">{{ $t("ic.arrowLeft") }}</v-icon
      >Go to home
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Error404",
  methods: {
    goHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
  margin-top: 60px;
}
</style>
